import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SchoolService } from "../service/school.service";
import { Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { MessageService } from "primeng/api";
import { EventService } from "../service/event.service";
import { SelectItem } from "primeng/api";
import { FormControl } from "@angular/forms";
import { PageNotFoundComponent } from "src/app/page-not-found/page-not-found.component";
import { ChangeDetectionStrategy, HostListener } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UpcomingEvent } from "../admin-interfaces";

import { Table } from "primeng/components/table/table";
import { IssoUtilService } from "src/app/services/isso-util.service";

@Component({
  selector: "app-manage-event-report",
  templateUrl: "./manage-event-report.component.html",
  styleUrls: ["./manage-event-report.component.css"],
  providers: [MessageService, ConfirmationService],
})
export class ManageEventReport implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  eventYear: string;
  loading: boolean;
  showspinner: boolean;
  selectedYear: string;
  eventServiceData: any;
  eventInfo: Event[];
  display: boolean;
  error: any;
  yearOptions: SelectItem[];
  yearvalue: number;
  showTable: boolean;
  constructor(
    private confirmation: ConfirmationService,
    private eventService: EventService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private router: Router,
    private issoUtilService: IssoUtilService,
    private schoolService: SchoolService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.setYear();
    this.getEventData();

    this.loadInitialData();
  }
  setYear() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();
    if (month >= 6) {
      this.selectedYear = year + "-" + (year + 1);
    } else {
      this.selectedYear = year - 1 + "-" + year;
    }
  }
  getEventData() {
    this.showspinner = true;

    this.eventService.getEventByYear(this.selectedYear).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.showspinner = false;
          this.eventServiceData = response;
          this.showTable = true;
          this.eventInfo = this.eventServiceData;
          const currentDate = new Date();
        } else {
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  loadInitialData() {
    this.yearOptions = this.issoUtilService.setYear();
  }
  onyeareChange(event) {
    this.yearvalue = event.value;
    this.selectedYear = event.value;
    this.eventService.getEventByYear(this.yearvalue).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.showspinner = false;
          this.eventServiceData = response;
          this.eventInfo = this.eventServiceData;
          if (this.eventServiceData.length > 0) {
            this.eventInfo = this.eventServiceData;
            this.showTable = true;
          } else {
            this.showTable = false;
            // this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: "Event not found",
            });
            //  alert('im blankl=')
          }
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  /** Human name for each flag, used in the confirmation copy and the toast. */
  private certificateLabel(type: string): string {
    if (type === "merit") { return "Merit certificates"; }
    if (type === "coachCertificate") { return "Coach certificates"; }
    return "Participation certificates";
  }

  /** True once the last day of the event is behind us. */
  private hasFinished(event: any): boolean {
    const last = (event && (event.endDate || event.startDate)) || null;
    if (!last) { return false; }
    const end = new Date(last);
    if (isNaN(end.getTime())) { return false; }
    end.setHours(23, 59, 59, 999);
    return end.getTime() < Date.now();
  }

  /**
   * Releasing is the last gate before certificates become downloadable, and a
   * certificate cannot be recalled once a school has it - so it is confirmed
   * rather than a bare toggle. Withdrawing is confirmed too: it pulls the
   * certificates back from every school and student straight away.
   *
   * Approving an event that has not finished is allowed - this screen is the
   * decision, and the backend no longer second-guesses it against the end date -
   * but it is called out, because certificates then go out for an event still
   * being run.
   */
  confirmChangeEventStatus(event: any, eventId, isStatus, type) {
    const approving = String(isStatus) === "0";
    const label = this.certificateLabel(type).toLowerCase();
    const name = (event && event.eventName) || "this event";
    const early = approving && !this.hasFinished(event);

    let message: string;
    if (!approving) {
      message = "Withdraw " + label + " for \"" + name + "\"? They will stop being downloadable for every school and student.";
    } else if (early) {
      message = "\"" + name + "\" is not over yet. Are you sure you want to release " + label
        + " before the event finishes? Schools and students who attended will be able to download them immediately.";
    } else {
      message = "Release " + label + " for \"" + name + "\"? Schools and students who attended will be able to download them immediately.";
    }

    this.confirmation.confirm({
      key: "confirm-certificate-release",
      icon: early ? "pi pi-exclamation-triangle" : "pi pi-info-circle",
      header: !approving ? "Withdraw certificates" : early ? "Event not finished" : "Approve certificates",
      message: message,
      acceptLabel: !approving ? "Yes, withdraw" : early ? "Yes, release early" : "Yes, approve",
      rejectLabel: "Cancel",
      accept: () => { this.changeEventStatus(eventId, isStatus, type); },
    });
  }

  changeEventStatus(eventId, isStatus, type) {
    const approving = String(isStatus) === "0";
    const formData = new FormData();
    formData.append("statusVal", approving ? "1" : "0");
    formData.append("certificateType", type);

    this.eventService.changeReportStatus(eventId, formData).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.messageService.add({
          key: "custom",
          severity: "success",
          summary: this.certificateLabel(type) + (approving ? " approved" : " withdrawn"),
        });
        this.display = false;
        this.getEventData();
      },
      (error) => (this.error = error)
    );
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
